import Stack from '@mui/material/Stack';
import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box } from '@mui/material';

import { useLangFile } from 'js/context/LanguageContext';

const buttonStyle = {
  textTransform: 'initial',
};

const ReplaceStationDialog = ({ shown, onClose, onYes, onNo }) => {
  const LangFile = useLangFile();

  return (
    <Dialog open={shown} maxWidth={'sm'} fullWidth onClose={onClose}>
      <DialogTitle>
        <Box
          sx={{
            textAlign: 'center',
            width: '100%',
          }}
        >
          {LangFile.ReplaceStationDialog.title}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 4,
          }}
        >
          <Box
            sx={{
              my: 1,
            }}
          >
            <Button
              variant={'contained'}
              color={'primary'}
              size={'large'}
              fullWidth
              onClick={onYes}
              style={buttonStyle}
            >
              <Stack
                direction={'column'}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    fontWeight: 600,
                    fontSize: 20,
                  }}
                >
                  {LangFile.ReplaceStationDialog.yes}
                </Box>
                <Box
                  sx={{
                    fontWeight: 400,
                    fontSize: 14,
                  }}
                >
                  {LangFile.ReplaceStationDialog.yesDescription}
                </Box>
              </Stack>
            </Button>
          </Box>

          <Box
            sx={{
              my: 1,
            }}
          >
            <Button
              variant={'contained'}
              color={'primary'}
              size={'large'}
              fullWidth
              onClick={onNo}
              style={buttonStyle}
            >
              <Stack
                direction={'column'}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    fontWeight: 600,
                    fontSize: 20,
                  }}
                >
                  {LangFile.ReplaceStationDialog.no}
                </Box>
                <Box
                  sx={{
                    fontWeight: 400,
                    fontSize: 14,
                  }}
                >
                  {LangFile.ReplaceStationDialog.noDescription}
                </Box>
              </Stack>
            </Button>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Button variant={'outlined'} onClick={onClose}>
            {LangFile.ReplaceStationDialog.back}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

ReplaceStationDialog.propTypes = {
  shown: PropTypes.bool,
  onClose: PropTypes.func,
  onYes: PropTypes.func,
  onNo: PropTypes.func,
};

export default ReplaceStationDialog;
